import { apiResponse, UserStore } from '@stores';
import { useQuery } from '@tanstack/react-query';
import { ViewCreatorStaleTime } from '@utils/queryCacheConfig';

export class UserProfileViewCreator {
  constructor(private readonly userStore: UserStore = new UserStore()) {}

  public async createView(userId: number) {
    const user = await apiResponse.handleApiResponse(() => this.userStore.ReadUser(userId));
    //TODO: in future we are going to need additional attributes from the user profile, not just user
    return {
      ...user,
    };
  }
}

export const useUserProfileViewCreator = (userId: number) =>
  useQuery({
    queryKey: [UserProfileViewCreator.name, userId],
    queryFn: () => new UserProfileViewCreator().createView(userId),
    staleTime: ViewCreatorStaleTime.UserProfileViewCreator,
  });
